









import Component, { mixins } from 'vue-class-component';
import BaseFormMixin from '@/mixins/base-form-mixin';
import DataprocessServices, { DpFlowDto } from '@/services/dataprocess';
import DatacollectServices, { DatacollectDto } from '@/services/datacollect';
import CategoryServices, { CategoryDto } from '@/services/category';
import { Watch } from 'vue-property-decorator';
import { confirmDelete } from '@/libs/decorator';
import { Mutation } from 'vuex-class';
import { graphFunc } from  '@/components/x6/';

@Component({
  components: {}
})
export default class DataprocessFlow extends mixins(BaseFormMixin) {
  breadList = [{ name: '数据加工任务流程' }];
  dpSrv = new DataprocessServices();
  dcSrv = new DatacollectServices();
  categorySrv = new CategoryServices();
  formData: DpFlowDto = {};
  id: any = 0;
  categoryId: any = 0;
  readonly: boolean = false;
  childShow = true;
  nodes: any[] = [];
  edges: any[] = [];
  collectJobList: DatacollectDto[] = [];
  keepalive: boolean = true;

  async initFormData() {
    // if (this.id) {
    //     // 详情或编辑
    //     let res = await this.dpSrv.getFlowInfo(this.id);
    //     if (!res) return false;
    //     this.formData = res;
    //     this.breadList = [{ name: this.formData.flowCategoryName || '' }, { name: this.formData.flowName || '' }, { name: '数据加工任务流程' }];
    // } else {
    //   this.formData = {
    //     flowCategoryId: this.categoryId,
    //   };
    // }
    this.formData = {
      flowCategoryId: this.categoryId,
    };
  }

  created() {
    this.id = this.$route.query.id;
    this.categoryId = this.$route.query.categoryId;
    this.initFormData();
  }

  mounted() {
    //this.handleSwitchDefault();
    this.listener();
  }

  activated() {
    //this.onIdChange();
  }

  listener() {
    graphFunc.GraphListener.doubleNodeClick((detail: any) => {
        console.log("[debug]detail:", detail);
    });
    graphFunc.GraphListener.runtimeError((err: any) => {
        console.log("[debug]errorCode, errorMsg:", err.errorCode, err.errorMsg);
    });
    graphFunc.GraphListener.flowSubmit((detail: any) => {
        console.log("[debug]jobName,jobCode:", detail.name, detail.code);
    });
  }

  // handleSwitchDefault() {
  //   if (this.formData.flowConfig) {
  //     let ret = JSON.parse(this.formData.flowConfig);
  //     this.nodes = ret.nodesJSON;
  //     this.edges = ret.edgesJSON;
  //     graphFunc.initDefaultData(this.nodes, this.edges);
  //     graphFunc.onlyLook(false); this.readonly = false;
  //   }
  // }
  
  refreshKeepalive() {
    if (!this.$route.query.keepalive) {
      this.keepalive = false;
      this.$router.push({
        query: { ...this.$route.query, keepalive: 'true' }
      });
    } else {
      this.keepalive = true;
    }
  }

  @Watch('$route')
  onRouteChange(to: any, from: any) {
    this.childShow= false;
    this.id = this.$route.query.id;
    this.categoryId = this.$route.query.categoryId;
    this.cache = this.isNeedCache(from, to);
    this.onIdChange();
    this.$nextTick(() => {
        this.childShow= true;
    });
  }

  @Watch('id')
  async onIdChange() {
    this.id = this.$route.query.id;
    let path = this.$route.path;

    if (path == '/data/dataprocess/flow/add') {
        //this.refreshKeepalive();
        //if (this.keepalive && this.cache) return false;
        this.initFormData();
        let category = await this.categorySrv.getInfo(this.categoryId);
        this.breadList = [{ name: category.categoryName }, { name: '创建数据加工任务流程' }];
        graphFunc.onlyLook(false);
        this.readonly = false;
    }

    if (path == '/data/dataprocess/flow/edit') {
        //if ((!this.id || this.id == this.formData.id) && this.cache) return false;

        let res = await this.dpSrv.getFlowInfo(this.id);
        if (!res) return false;
        let ret = JSON.parse(res.flowConfig);
        this.nodes = ret.nodesJSON;
        this.edges = ret.edgesJSON;
        graphFunc.initDefaultData(this.nodes, this.edges);
        graphFunc.onlyLook(false);
        this.readonly = false;
        this.formData.id = this.id;
        this.formData = res;
        this.breadList = [{ name: res.flowCategoryName || '' }, { name: res.flowName || '' }, { name: '修改数据加工任务流程' }];
    }

    if (path == '/data/dataprocess/flow/detail') {
        //if (!this.id || this.$route.path != '/data/dataprocess/flow/detail') return false;

        let res = await this.dpSrv.getFlowInfo(this.id);
        if (!res) return false;
        let ret = JSON.parse(res.flowConfig);
        this.nodes = ret.nodesJSON;
        this.edges = ret.edgesJSON;
        graphFunc.initDefaultData(this.nodes, this.edges);
        graphFunc.onlyLook(true);
        this.readonly = true;
        this.formData.id = this.id;
        this.formData = res;
        this.breadList = [{ name: res.flowCategoryName || '' }, { name: res.flowName || '' }, { name: '查看数据加工任务流程' }];
    }

    this.collectJobList = await this.dcSrv.getList({ status_eq: 0, templateFlag_eq: 1 });

  }

  handleNodeClick(e: any) {
    console.log("[debug]节点单击Emit事件:", e);
  }

  //@confirmDelete() async 
  handleNodeRemove(e: any) {
      console.log("[debug]节点删除Emit事件:", e);
      // let nodeInfo = await this.dpSrv.getInfoByNode(this.id, e.nodeId);
      // if (nodeInfo) {
      //   let res = await this.dpSrv.remove(nodeInfo.id);
      //   if (res) {
      //     this.$message.success('删除成功');
      //   }
      // }
  }

  async handleNodeDblClick(e: any) {
      console.log("[debug]节点双击Emit事件:", e);
      if (!this.id) {
        this.$message.error("请先保存任务流程"); 
        return false;
      }
      let nodeList = this.nodes.filter(v => v.id === e.nodeId);
      if (!nodeList || nodeList.length <= 0) {
        this.$message.error("请先保存任务流程"); 
        return false;
      }

      let parentJobCode = '';
      if (e.parentNodeId) {
        let parentNode = await this.dpSrv.getInfoByNode(this.id, e.parentNodeId)
        if (parentNode) {
          parentJobCode = parentNode.processJobCode;
        } else {
          parentNode = await this.dcSrv.getInfoByNode(this.id, e.parentNodeId)
          if (parentNode) {
            parentJobCode = parentNode.collectJobCode;
          } else {
            this.$message.error("请先更新上一节点信息"); 
            return false;
          }
        }
      }

      if ('FlinkSQL' === e.jobType || e.label.indexOf("FlinkSQL") >= 0 ) {
        let nodeInfo = await this.dpSrv.getInfoByNode(this.id, e.nodeId);
        if (nodeInfo) {
          this.$router.push(`/data/dataprocess/flow/flinksql?id=${nodeInfo.id}&taskFlowId=${this.id}&taskNodeId=${e.nodeId}&parentJobCode=${parentJobCode}`);
        } else {
          this.$router.push(`/data/dataprocess/flow/flinksql?taskFlowId=${this.id}&taskNodeId=${e.nodeId}&parentJobCode=${parentJobCode}`);
        }
      } else if ('Doris' === e.jobType || e.label.indexOf("Doris") >= 0 ) {
        let nodeInfo = await this.dpSrv.getInfoByNode(this.id, e.nodeId);
        if (nodeInfo) {
          this.$router.push(`/data/dataprocess/flow/doris?id=${nodeInfo.id}&taskFlowId=${this.id}&taskNodeId=${e.nodeId}&parentJobCode=${parentJobCode}`);
        } else {
          this.$router.push(`/data/dataprocess/flow/doris?taskFlowId=${this.id}&taskNodeId=${e.nodeId}&parentJobCode=${parentJobCode}`);
        }
      } else if ('Python' === e.jobType || e.label.indexOf("Python") >= 0) {
        let nodeInfo = await this.dpSrv.getInfoByNode(this.id, e.nodeId);
        if (nodeInfo) {
          this.$router.push(`/data/dataprocess/flow/python?id=${nodeInfo.id}&taskFlowId=${this.id}&taskNodeId=${e.nodeId}&parentJobCode=${parentJobCode}`);
        } else {
          this.$router.push(`/data/dataprocess/flow/python?taskFlowId=${this.id}&taskNodeId=${e.nodeId}&parentJobCode=${parentJobCode}`);
        }
      } else if ('Shell' === e.jobType || e.label.indexOf("Shell") >= 0) {
        let nodeInfo = await this.dpSrv.getInfoByNode(this.id, e.nodeId);
        if (nodeInfo) {
          this.$router.push(`/data/dataprocess/flow/shell?id=${nodeInfo.id}&taskFlowId=${this.id}&taskNodeId=${e.nodeId}&parentJobCode=${parentJobCode}`);
        } else {
          this.$router.push(`/data/dataprocess/flow/shell?taskFlowId=${this.id}&taskNodeId=${e.nodeId}&parentJobCode=${parentJobCode}`);
        }
      } else if ('Collect' === e.jobType || e.label.indexOf("采集") >= 0) {
        // let collectDto: DatacollectDto = {
        //   collectJobCode: e.jobCode,
        //   taskNodeId: e.nodeId,
        //   taskFlowId: this.id,
        //   parentJobCode: parentJobCode
        // };
        // if (e.jobCode === parentJobCode) {
        //   this.$message.error("不能跟上一节点是相同的采集作业"); 
        //   return false;
        // }
        // let res = await this.dcSrv.updateByCode(collectDto);
        // if (res) {
        //   this.$message.success('更新数据采集作业节点成功');
        //   this.replaceUrlWithOutConfirm('/data/dataprocess/flow/detail?id=' + this.id);
        // }
        let nodeInfo = await this.dcSrv.getInfoByNode(this.id, e.nodeId);
        if (nodeInfo) {
          this.$router.push(`/data/datacollect/edit?id=${nodeInfo.id}&categoryId=${nodeInfo.collectCategoryId}&taskFlowId=${this.id}&taskNodeId=${e.nodeId}&parentJobCode=${parentJobCode}`);
        } else {
          let templateList = await this.dcSrv.getList({ collectJobCode_eq: e.jobCode, templateFlag_eq: 1 });
          if (templateList.length > 0) {
            let templateInfo = templateList[0];
            this.$router.push(`/data/datacollect/add?templateId=${templateInfo.id}&categoryId=${templateInfo.collectCategoryId}&taskFlowId=${this.id}&taskNodeId=${e.nodeId}&parentJobCode=${parentJobCode}`);
          } else {
            this.$message.error("采集作业模板信息不存在"); 
            return false;
          }
        }
      }
  }

  async handleJobLink(e: any) {
      // console.log("[debug]关联任务作业emit事件:", e);
      // if (!this.id) {
      //   this.$message.error("请先保存任务流程"); 
      //   return false;
      // }
      // let nodeList = this.nodes.filter(v => v.id === e.nodeId);
      // if (!nodeList || nodeList.length <= 0) {
      //   this.$message.error("请先保存任务流程"); 
      //   return false;
      // }
  }

  async handleFlowSubmit(e: any) {
      console.log("[debug]提交任务流程emit事件:", e);
      let ret = graphFunc.graphValidate();
      if (!ret.ok) {
        this.$message.error(ret.errs.join());
        return false;
      }

      const data = graphFunc.exportData();
      this.nodes = data.nodesJSON;
      this.edges = data.edgesJSON;

      this.formData = {
        id: this.id,
        flowCategoryId: this.categoryId,
        flowCode: e.code,
        flowName: e.name,
        flowType: 0, //数据加工
        flowDesc: e.desc,
        flowConfig: JSON.stringify(data),
        status: 0
      };

      let res;
      if (this.id) {
        res = await this.dpSrv.updateFlow(this.formData);
        if (res) {
          this.$message.success('更新流程成功');
          this.replaceUrlWithOutConfirm('/data/dataprocess/flow/detail?id=' + this.id);
        }
      } else {
        res = await this.dpSrv.addFlow(this.formData);
        if (res) {
          this.$message.success('新建流程成功');
          this.replaceUrlWithOutConfirm('/data/dataprocess/flow/detail?id=' + res.id);
        }
      }
      this.HANDLE_RELOAD_DS_MENU();
  }
  @Mutation HANDLE_RELOAD_DS_MENU: any;
}
